import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import noWishlist from "../../assets/imgs/notFound/noWishlist.png";
import axios from "../../requests/axios";
import routes from "../../requests/routes";
import MyWishlist from "./My Wishlist/MyWishlist";
import PersonalInfo from "./Personal Information/PersonalInfo";
import classes from "./profile.module.scss";
import ProfileBar from "./ProfileBar";
import { useSearchParams } from "react-router-dom";
import UserProfileReviews from "./UserProfileReviews/UserProfileReviews";
import MyBlog from "./MyBlog/MyBlog";
import ProfileAvatar from "./ProfileAvatar/ProfileAvatar";

const Profile = () => {
  const myUser = useSelector((state) => state.user);
  const id = myUser.id;
  const [user, setUser] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();

  async function getUser() {
    try {
      const response = await axios.get(routes.getUser + id);
      setUser(response.data);
    } catch (err) {}
  }
  useEffect(() => {
    getUser();
  }, []);

  return (
    <div className={classes.container}>
      <section className={classes.profile}>
        <div className={classes.profile__info}>
          <div className={classes.profile__info__image}>
            <ProfileAvatar
              user={user}
              onUpdated={(newUrl) => {
                // update your local user state so UI refreshes instantly
                setUser((prev) => ({ ...prev, image: newUrl }));
              }}
            />
          </div>
          <div className={classes.profile__info__details}>
            <h2 className={classes.profile__info__details__name}>
              {user.fullName}
            </h2>
            <div className={classes.extraDetails}>
              {/* <h2 className={classes.profileTitle}>Type: {user.type}</h2> */}
              <h2 className={classes.profileTitle}>Points: +{user.points}</h2>
            </div>
          </div>
        </div>
        <ProfileBar />
      </section>

      <div className={classes.sections}>
        {searchParams.get("tab") === "Wishlist" ? (
          <>
            {user.wishlist === 0 ? (
              <div className={classes.emptyFeed}>
                <div className={classes.noFeed}>
                  <img src={noWishlist} alt="" />
                  <div className={classes.letsFill}>NO LIKES YET</div>
                </div>
              </div>
            ) : (
              <MyWishlist user={user} wishlist={true} />
            )}
          </>
        ) : null}
        {searchParams.get("tab") === "Profile Info" ? (
          <PersonalInfo user={user} id={user._id} />
        ) : null}
        {searchParams.get("tab") === "Reviews" ? (
          <UserProfileReviews userId={id} />
        ) : null}
        {searchParams.get("tab") === "Blog" ? <MyBlog userId={id} /> : null}
      </div>
    </div>
  );
};

export default Profile;
